export enum SortTokenName {
  VIEW = "VIEW",
  RECENT = "RECENT",
  LIKE = "LIKE",
  COMMENT = "COMMENT",
}
